(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name HistanalisisController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('HistanalisisController', HistanalisisController);

    HistanalisisController.$inject = ["GenerallabService","$uibModal","AnalisisService","$timeout","$location",'$anchorScroll','NotificacionesService'];

    function HistanalisisController(GenerallabService,$uibModal,AnalisisService,$timeout,$location,$anchorScroll,NotificacionesService)
    {

    	var vm = this;
        vm.filtros = { page : 0, tipo_peticion : "Lab" };
        vm.loadingAnaliticas = {};
        vm.analiticas = {};
        vm.loading = false;
        vm.generalLav = GenerallabService;
        vm.notificacion = NotificacionesService;

        vm.generalLav.optionsMultiplePicker.changeCallback = function(){
            $timeout(function(){
                vm.init(0);
            });
        }
        vm.generalLav.optionsMultiplePicker.eventHandlers = {
            'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                vm.init(0);
            }); }
        }
        
    	vm.analisis = [];
        vm.datetomaoptions = {
            /*changeCallback: function(){
                $timeout(function(){
                    vm.init();
                });
            },*/
            singleDatePicker: true,
            maxDate : moment(),
            opens:'center',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                clearLabel: 'Limpiar',
                separator: ' - ',
                format: "DD-MM-YYYY",
            },
            ranges: {
                'Hoy': [moment(), moment()],
                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.init(0);
                }); },
                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.init(0);
                }); }
            }/*,
            cancelOnOutsideClick:true*/
        };
        vm.dateresultoptions = {
            /*changeCallback: function(){
                $timeout(function(){
                    vm.init(0);
                });
            },*/
            maxDate : moment(),
            opens:'center',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                clearLabel: 'Limpiar',
                separator: ' - ',
                format: "DD-MM-YYYY",
            },
            ranges: {
                'Hoy': [moment(), moment()],
                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.init(0);
                }); },
                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.init(0);
                }); }
            }/*,
            cancelOnOutsideClick:true*/
        };
        //{changeCallback : function()ha.init};
        vm.nextPage = function(){
            vm.filtros.page++;
        }
    	vm.init = function(page){
            console.log("pageinit",page);
            console.log("pafeFilt",vm.filtros.page);
            if(typeof(page)!='undefined'){
                vm.filtros.page = page;
            }
            if(!vm.loading){
                vm.loading = true;
                //console.log(vm.filtros);
        		AnalisisService.getHistAnalisisCentro(vm.filtros,function(data){
                    console.log("page",page);
                    if(typeof(page)!='undefined'){

                        $timeout(function(){
                            $('.historialtable').scrollTop(0);
                            vm.analisis = data.analisis;
                        });
                    }else{
                        vm.analisis = vm.analisis.concat(data.analisis);
                    }
                    $timeout(function(){
                        vm.loading = false;
                    });
                    
                });
            }
    	};
        vm.vermas = function(muestra){
            if(!vm.analiticas[muestra.id]){
                vm.loadingAnaliticas[muestra.id] = true;
                AnalisisService.getAnaliticasByMuestra(muestra.id,function(data){
                    vm.loadingAnaliticas[muestra.id] = false;
                    vm.analiticas[muestra.id] = data.analiticas;
                });
            }
        };

      
        vm.cambiarPacienteMod = "";
        vm.cambiarPaciente = function(muestra,e){
            vm.cambiarPacienteMod = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'cambiarpaciente.html',
                  size: 'right',
                  backdrop:'static',
                  controller: function($scope) {
                    console.log($scope);
                    $scope.seleccionarPac = function(animal_id,muestra_id){
                        console.log(animal_id);
                        console.log(muestra_id);
                        AnalisisService.cambiarPaciente(animal_id,muestra_id,function(data){
                            vm.init(0);
                            console.log(data);
                            vm.cambiarPacienteMod.close();
                        });
                    }
                    $scope.muestra = muestra;
                    $scope.okForm = function(){
                        vm.cambiarPacienteMod.close();
                    }
                    $scope.koForm = function(){
                        vm.cambiarPacienteMod.close();
                    }
                   
                  }
             });
            console.log(e);
            e.preventDefault();
            //e.stopPropagation();
            //return false;
        }
        vm.init(0);
               
    }


})();